import { useGamesStatsQuery } from '~/redux/apis/user-stats-api'
import GameStatsPanel from '~/statistics-v2/components/GameStatsPanel'

/**
 * `GameStatsPanel` bound to `/v1/user-stats/games`.
 *
 * Without `familyMemberId` the endpoint answers about the signed-in user, so the parent view must
 * pass the child's id. The date range is sent but ignored server-side.
 *
 * `curriculum` / `grade` scope the cards to what the learner played while on that curriculum or
 * grade; passing neither gives the lifetime figures the all-math view shows. Stack'n Load ignores
 * the scope — its Firestore progress carries no curriculum — so the panel labels that one card.
 */
export default function GamesStats({
  curriculum,
  familyMemberId,
  grade,
}: {
  curriculum?: string
  familyMemberId?: number
  grade?: string
}): React.ReactElement {
  // Scope-only args: the endpoint ignores a date range, and `useGetUserStats` queries the same
  // shape for the headline figures, so both share one cache entry rather than firing two requests.
  const { data: gamesStats } = useGamesStatsQuery({ familyMemberId, curriculum, grade })

  return <GameStatsPanel isScoped={Boolean(curriculum || grade)} stats={gamesStats} />
}
